/* eslint-disable @typescript-eslint/naming-convention */

import { Action } from '@ngrx/store';

export enum TaskTabActionTypes {
	ADD_TASK_TAB = '[Add Task Tab] Add Task Tab to the Tasks Tab Collection',
	REMOVE_TASK_TAB = '[Remove Task Tab] Remove Task Tab from the Tasks Tab Collection',
	UPDATE_TASK_TAB_HEADER_TEXT = '[Update Task Tab Header Text] Updates the Task Tab Header Text',
}

export class AddTaskTab implements Action {
	readonly type = TaskTabActionTypes.ADD_TASK_TAB;
	constructor(public payload: { tabKey: number, route: string, headerText: string }) {}
}

export class RemoveTaskTab implements Action {
	readonly type = TaskTabActionTypes.REMOVE_TASK_TAB;
	constructor(public payload: { tabKey: number }) {}
}

export class UpdateTaskTabHeaderText implements Action {
	readonly type = TaskTabActionTypes.UPDATE_TASK_TAB_HEADER_TEXT;
	constructor(public payload: { tabKey: number, headerText: string }) {}
}

export type TaskTabActions =
	| AddTaskTab
	| RemoveTaskTab
	| UpdateTaskTabHeaderText;
